import React from "react";
import {LoaderAnimate} from '../../../components/LoaderAnimate'

const ModalLoading = ({ titulo = "Advertencia", cuerpo, onCancel }) => {
  return (
    <div id="centeredModal" className="modal-wrapper modal-is-open">
      <div className="overlay"></div>
      <div className="modal modal-centered">
        <div className="modal-content rounded-lg bg-white p-10 flex flex-col items-center justify-center w-2/3">
         <LoaderAnimate/>
          <div className="text-primary text-opacity-700 text-3xl text-center mt-5 font-bold leading-none">
            ¡Un momento por favor!
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLoading;
